import React from 'react';

const PrintPreviewFunctions = ({
    pages,
    totalPages,
    previewStyle,
    contentStyle,
    checkboxOptions,
    projectScanForSend,
    headerStyle,
    headerFooterStyle,
    footerStyle,
    tableStyle,
    tableHeaderStyle,
    tableCellStyle,
    scaleFactor,
    previewHeight,
    marginSize
}) => {
    const renderPage = (pageData) => {
        const { pageNumber, content, isSpreadsheet } = pageData;

        return (
            <div key={pageNumber} className="print-preview" style={previewStyle}>
                {/* Header area with file name and timestamp */}
                {(checkboxOptions.withProjectName || checkboxOptions.withTimestamp) && (
                    <div className="print-preview-header print-preview-header-footer" style={{ ...headerStyle, ...headerFooterStyle }}>
                        {checkboxOptions.withProjectName && (
                            <span>
                                {projectScanForSend["Project Name"] || "my_document.docx"}
                            </span>
                        )}
                        {checkboxOptions.withTimestamp && <span>{new Date().toLocaleString()}</span>}
                    </div>
                )}

                <div className="print-preview-content" style={contentStyle}>
                    {isSpreadsheet ? (
                        // Render spreadsheet format with split content
                        <table style={tableStyle}>
                            <thead>
                                <tr>
                                    <th style={{ ...tableHeaderStyle, width: '25%' }}>Card Data</th>
                                    <th style={{ ...tableHeaderStyle, width: '50%' }}>Card Content</th>
                                    <th style={{ ...tableHeaderStyle, width: '25%' }}>Tags</th>
                                </tr>
                            </thead>
                            <tbody>
                                {content.map(([key, rowData, type]) => {
                                    if (type === 'main') {
                                        return (
                                            <tr key={key}>
                                                <td style={{ ...tableCellStyle, width: '25%' }}>
                                                    {!rowData.isContentContinuation && checkboxOptions.withCardTitle && rowData["Card Title"] && (
                                                        <p style={{ margin: `0 0 ${6 * scaleFactor}px 0`, fontSize: `${12 * scaleFactor}px` }}>
                                                            {rowData["Card Title"]}
                                                        </p>
                                                    )}
                                                    {!rowData.isContentContinuation && checkboxOptions.withCardMetadata && rowData["Card Metadata"] && (
                                                        <p style={{ margin: `0 0 ${6 * scaleFactor}px 0`, fontSize: `${12 * scaleFactor}px` }}>
                                                            {rowData["Card Metadata"]}
                                                        </p>
                                                    )}
                                                </td>
                                                <td style={{ ...tableCellStyle, width: '50%' }}>
                                                    <div dangerouslySetInnerHTML={{ __html: rowData.Content }} />
                                                </td>
                                                <td style={{ ...tableCellStyle, width: '25%' }}>
                                                    {!rowData.isContentContinuation && checkboxOptions.withTags && rowData["Tags"] && (
                                                        <p style={{ margin: 0, fontSize: `${12 * scaleFactor}px` }}>
                                                            {rowData["Tags"]}
                                                        </p>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    } else {
                                        // Annotation row
                                        return (
                                            <tr key={key}>
                                                <td style={{ ...tableCellStyle, width: '25%' }}>
                                                    {!rowData.isAnnotationContinuation && (
                                                        <p style={{ margin: 0, fontSize: `${12 * scaleFactor}px` }}>
                                                            Annotation for: {rowData["Card Metadata"] || "Card"}
                                                        </p>
                                                    )}
                                                </td>
                                                <td style={{ ...tableCellStyle, width: '50%' }}>
                                                    <div dangerouslySetInnerHTML={{ __html: rowData.Annotation }} />
                                                </td>
                                                <td style={{ ...tableCellStyle, width: '25%' }}>
                                                    {/* Empty cell */}
                                                </td>
                                            </tr>
                                        );
                                    }
                                })}
                            </tbody>
                        </table>
                    ) : (
                        // Render original document format with split content
                        content.map((element, index) => {
                            return (
                                <div
                                    key={`${pageNumber}-${element.originalIndex}-${element.chunkIndex || 0}-${index}`}
                                    className="print-preview-paragraph"
                                    style={element.styles}
                                    dangerouslySetInnerHTML={{ __html: element.content }}
                                />
                            );
                        })
                    )}
                </div>

                {/* Footer area with page number */}
                {checkboxOptions.withPageNumbers && (
                    <div className="print-preview-footer print-preview-header-footer" style={{ ...footerStyle, ...headerFooterStyle }}>
                        Page {pageNumber} of {totalPages}
                    </div>
                )}
            </div>
        );
    };

    const isSpreadsheetFormat = pages.length > 0 && pages[0].isSpreadsheet;

    return (
        <div
            className="print-preview-container"
            style={{
                maxHeight: '1000px',
                maxWidth: '900px',
                overflowY: 'auto',
                overflowX: 'hidden',
                border: '1px solid #ccc',
                borderRadius: '4px',
                padding: '20px',
                backgroundColor: '#f5f5f5',
                scrollBehavior: 'smooth'
            }}
        >
            {pages.map(pageData => renderPage(pageData))}

            {/* Debug info - remove in production */}
            <div style={{
                fontSize: '12px',
                color: '#666',
                textAlign: 'center',
                marginTop: '10px'
            }}>
                Total Pages: {totalPages}
            </div>
        </div>
    );
};

export default PrintPreviewFunctions;